import { Injectable } from '@angular/core';
import { QueryEntity, StateHistoryPlugin } from '@datorama/akita';
import { UntilDestroy } from '@ngneat/until-destroy';
import { GlobalState, GlobalStateStore } from './global.appstate.store';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class GlobalStateQuery extends QueryEntity<GlobalState> {
    selectMuted$ = this.select(state => state.ui.muted);
    selectedServerName$ = this.select(state => state.ui.selectedServerName);

    constructor(protected store: GlobalStateStore) {
        super(store);
    }
}
